import React from "react";
import styled from "styled-components";

const FormButtonDanger = ({ children, size, disabled, ...props }) => {

  if (size === "extraSmall") {
    return (
      <ButtonDangerExtraSmall $disabled={disabled} disabled={disabled}  {...props}>
        {children}
      </ButtonDangerExtraSmall>
    );
  }

  if (size === "small") {
    return (
      <ButtonDangerSmall $disabled={disabled} disabled={disabled} {...props}>
        {children}
      </ButtonDangerSmall>
    );
  }

  return (
    <ButtonDanger $disabled={disabled} disabled={disabled} {...props}>
      {children}
    </ButtonDanger>
  );
};

const ButtonDanger = styled.button`
  flex-shrink: 0;
  padding: 11px 60px;
  background-color: var(--aia-bx-red-1);
  color: var(--aia-bx-white);
  border: 1px solid var(--aia-bx-red-1);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;

  ${props => props.$disabled ? `
      cursor: not-allowed;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: var(--aia-bx-red-4);
    }
  `};
`;


const ButtonDangerSmall = styled.button`
  flex-shrink: 0;
  padding: 8px 30px;
  background-color: var(--aia-bx-red-1);
  color: var(--aia-bx-white);
  border: 1px solid var(--aia-bx-red-1);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;

  ${props => props.$disabled ? `
      cursor: not-allowed;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: var(--aia-bx-red-4);
    }
  `};
`;

const ButtonDangerExtraSmall = styled.button`
  flex-shrink: 0;
  padding: 5px 20px;
  background-color: var(--aia-bx-red-1);
  color: var(--aia-bx-white);
  border: 1px solid var(--aia-bx-red-1);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  visibility: visible;

  ${props => props.$disabled ? `
      cursor: not-allowed;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: var(--aia-bx-red-4);
    }
  `};
`;


export default FormButtonDanger;